import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  content: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    paddingBottom: theme.spacing.space20,
  },
  title: {
    paddingBottom: theme.spacing.space24,
  },
  description: {
    textAlign: "center",
  },
}));
